// extracted by mini-css-extract-plugin
export default {"container":"Wait_container__DReOG","contents":"Wait_contents__yQGeU"};